export default __webpack_public_path__ + "static/media/art-pro-brw-1.8b81fae2.png";